// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1feXk","label":"Category_label__2t2hU","content":"Category_content__2xIWJ","header":"Category_header__C3iZT","location":"Category_location__ZJ_Xm"};